export const CONTEXT_MENU_OFFSET_PX = 5
export const DEFAULT_COLUMN_MIN_WIDTH = 60
export const DEFAULT_COLUMN_WIDTH = 200
